import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import {
    socMedOptions,
    prospekCategoryOptions,
    prospekTypeOptions,
    prospekSourceOptions,
    memberLevelOptions, loyaltyLevelOptions
} from "../../config/constants";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import M from "moment/moment";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import * as R from "ramda";
import DateRange from "../../../payment/common/dateRange";
import {defaultFilter} from "../config";
import {mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import Api from "../../../../../Services/Api";

class CRMAssignFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: defaultFilter,
            prospekCategoryOptions: prospekCategoryOptions,
            prospekTypeOptions: prospekTypeOptions,
            prospekSourceOptions: prospekSourceOptions,
            provinceOptions: [],
            kabkotOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            kodePosOptions: [],
            levelOptions: memberLevelOptions,
            loyaltyOptions: loyaltyLevelOptions,
            hobbyOptions: [],
            interestOptions: [],
            socMedOptions: socMedOptions,
            kodePosRaw: [],
        };
    };

    async componentDidMount() {
        this.fetchHobbyAndInterest();
        this.fetchDataProvince();
        if (!R.isNil(this.props.search)) {
            let search = this.props.search;
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...defaultFilter,
                    ...search,
                    kodeCabang: !R.isNil(search.kodeCabang?.value) ? null : search.kodeCabang,
                }
            }));
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.filter?.idProvince?.value !== this.state.filter?.idProvince?.value) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    idKabkot: R.isNil(this.state.filter.idProvince) ? null : this.props.search?.idKabkot || null,
                    kecamatan: R.isNil(this.state.filter.idProvince) ? null : this.props.search?.kecamatan || null,
                    kelurahan: R.isNil(this.state.filter.idProvince) ? null : this.props.search?.kelurahan || null,
                    kodePos: R.isNil(this.state.filter.idProvince) ? null : this.props.search?.kodePos || null,
                },
                kecamatanOptions: [],
                kelurahanOptions: [],
                kodePosOptions: [],
            }));
            this.fetchDataKabKot(this.state.filter?.idProvince?.value);
        }
        if (prevState.filter?.idKabkot?.value !== this.state.filter?.idKabkot?.value) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    kecamatan: R.isNil(this.state.filter.idKabkot) ? null : this.props.search?.kecamatan || null,
                    kelurahan: R.isNil(this.state.filter.idKabkot) ? null : this.props.search?.kelurahan || null,
                    kodePos: R.isNil(this.state.filter.idKabkot) ? null : this.props.search?.kodePos || null,
                },
                kelurahanOptions: [],
                kodePosOptions: [],
            }));
            this.fetchDataKecamatan(this.state.filter?.idKabkot?.value);
        }
        if (prevState.filter?.kecamatan?.value !== this.state.filter?.kecamatan?.value) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    kelurahan: R.isNil(this.state.filter.kecamatan) ? null : this.props.search?.kelurahan || null,
                    kodePos: R.isNil(this.state.filter.kecamatan) ? null : this.props.search?.kodePos || null,
                },
                kodePosOptions: [],
            }));
            this.fetchDataKelurahan(this.state.filter?.kecamatan?.value);
        }
        if (prevState.filter?.kelurahan?.value !== this.state.filter?.kelurahan?.value && !R.isEmpty(this.state.kodePosRaw)) {
            const data = this.state.kodePosRaw.find(item => item.id === this.state.filter?.kelurahan?.value);
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    kodePos: R.isNil(this.state.filter.kelurahan) ? null : this.props.search?.kodePos || null,
                },
                kodePosOptions: !R.isEmpty(data) ? [mapToObjectDDL(data?.zipcode, data?.zipcode)] : [],
            }));
        }
    };

    fetchDataProvince = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllProvince();
            if (response.ok && !R.isEmpty(response.data.data)) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    provinceOptions: response.data.data.map(item =>
                        mapToObjectDDL(item.provinceName, item.id)
                    ),
                }));
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKabKot = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id)
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    kabkotOptions: response.data.data.map(item =>
                        mapToObjectDDL(item.kabKotName, item.kabKotId))
                }))
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKecamatan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(id)
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    kecamatanOptions: response.data.data.map(item =>
                        mapToObjectDDL(item.kecamatanName, item.id))
                }))
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    fetchDataKelurahan = async (id) => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(id)
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    kelurahanOptions: response.data.data.map(item =>
                        mapToObjectDDL(item.kelurahanname, item.id)
                    ),
                    kodePosRaw: response.data.data,
                }))
            }
        } catch (e) {
            console.log("errors", e);
        }
    };

    handleReset = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filter: defaultFilter,
        }));
    };

    handleSubmit = async () => {
        let resetValueFilter = false;
        if (JSON.stringify(defaultFilter) === JSON.stringify(this.state.filter)) {
            resetValueFilter = true;
            this.props.onSetState((prevValue) => ({
                ...prevValue,
                submittedFilter: {},
            }));
        }
        await this.setState((prevValue) => ({
            ...prevValue,
            filter: {
                ...prevValue.filter,
                appointmentDate: removeNullFields(this.state.filter?.appointmentDate),
                prospectDate: removeNullFields(this.state.filter?.prospectDate),
                followUpDate: removeNullFields(this.state.filter?.followUpDate),
            },
        }));
        this.props.onSubmit(removeNullFields(this.state.filter), resetValueFilter);
    };

    async fetchHobbyAndInterest() {
        const responses = await Promise.all([
            Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam({paramFilters: {bizparCategory: "HOBBY_TYPE"}}),
            Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam({paramFilters: {bizparCategory: "INTEREST_TYPE"}}),
        ]);

        if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                hobbyOptions: responses[0].data.data.map(item => mapToObjectDDL(item.value, item.key))
            }));
        }

        if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                interestOptions: responses[1].data.data.map(item => mapToObjectDDL(item.value, item.key))
            }));
        }
    }

    onDateChange = (key, name, value) => {
        if (R.equals(name, "tanggalAkhir")
            && !R.isNil(this.state.filter[key]?.tanggalAwal)
            && M(value, "DD-MM-YYYY").isBefore(M(this.state.filter[key].tanggalAwal, "DD-MM-YYYY"))
        ) {
            this.setState((prevValue) => ({
                ...prevValue,
                filter: {
                    ...prevValue.filter,
                    [key]: {
                        tanggalAwal: M(value).format("DD-MM-YYYY"),
                        tanggalAkhir: M(value).format("DD-MM-YYYY"),
                    }
                },
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            filter: {
                ...prevValue.filter,
                [key]: {
                    ...prevValue.filter[key],
                    [name]: value,
                }
            }
        }));
    };

    setValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filter: {
                ...prevValue.filter,
                [name]: value,
            }
        }))
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <SimpleInput
                            name="kodeCabang"
                            label="Kode Cabang"
                            value={this.state.filter?.kodeCabang}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <DateRange
                            data={this.state.filter?.prospectDate}
                            label="Tanggal Prospek"
                            startDateName="startDate"
                            endDateName="endDate"
                            onStartDateChange={(name, value) =>
                                this.onDateChange("prospectDate", name, M(value).format("DD-MM-YYYY"))
                            }
                            onEndDateChange={(name, value) =>
                                this.onDateChange("prospectDate", name, M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleInput
                            name="prospectName"
                            label="Nomor Prospek"
                            value={this.state.filter?.prospectName}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_prospek_category"
                            box="search"
                            name="prospectCategory"
                            label="Kategori Prospek"
                            options={this.state.prospekCategoryOptions}
                            value={this.state.filter?.prospectCategory}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_prospek_type"
                            box="search"
                            name="prospectKind"
                            label="Jenis Prospek"
                            options={this.state.prospekTypeOptions}
                            value={this.state.filter?.prospectKind}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_prospek_source"
                            box="search"
                            name="prospectSource"
                            label="Asal Prospek"
                            options={this.state.prospekSourceOptions}
                            value={this.state.filter?.prospectSource}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleInput
                            name="sourceCabang"
                            label="Cabang Asal"
                            value={this.state.filter?.sourceCabang}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="prospectOwnership"
                            label="Pemilik Prospek"
                            value={this.state.filter?.prospectOwnership}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="lastSeller"
                            label="Penjual Terakhir"
                            value={this.state.filter?.lastSeller}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <DateRange
                            data={this.state.filter?.followUpDate}
                            label="Last Follow Up Date"
                            startDateName="startLastDateFollowUp"
                            endDateName="endLastDateFollowUP"
                            onStartDateChange={(name, value) =>
                                this.onDateChange("followUpDate", name, M(value).format("DD-MM-YYYY"))
                            }
                            onEndDateChange={(name, value) =>
                                this.onDateChange("followUpDate", name, M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleInput
                            name="status"
                            label="Last Follow Up Status"
                            value={this.state.filter?.status}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="lastFollowUpBy"
                            label="Last Follow Up By"
                            value={this.state.filter?.lastFollowUpBy}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <DateRange
                            data={this.state.filter?.appointmentDate}
                            label="Next Appointment Date"
                            startDateName="startNextAppointment"
                            endDateName="endNextAppointment"
                            onStartDateChange={(name, value) =>
                                this.onDateChange("appointmentDate", name, M(value).format("DD-MM-YYYY"))
                            }
                            onEndDateChange={(name, value) =>
                                this.onDateChange("appointmentDate", name, M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleInput
                            name="information"
                            label="Keterangan"
                            value={this.state.filter?.information}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="nama"
                            label="Nama"
                            value={this.state.filter?.nama}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="nik"
                            label="NIK"
                            value={this.state.filter?.nik}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="handPhoneNumber"
                            label="No HP 1"
                            value={this.state.filter?.handPhoneNumber}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="handPhoneNumber2"
                            label="No HP 2"
                            value={this.state.filter?.handPhoneNumber2}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleInput
                            name="alamat"
                            label="Alamat"
                            value={this.state.filter?.alamat}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_province"
                            box="search"
                            name="idProvince"
                            label="Provinsi"
                            options={this.state.provinceOptions}
                            value={this.state.filter?.idProvince}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kabkot"
                            box="search"
                            name="idKabkot"
                            label="Kota/Kabupaten"
                            options={this.state.kabkotOptions}
                            value={this.state.filter?.idKabkot}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kecamatan"
                            box="search"
                            name="kecamatan"
                            label="Kecamatan"
                            options={this.state.kecamatanOptions}
                            value={this.state.filter?.kecamatan}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_kelurahan"
                            box="search"
                            name="kelurahan"
                            label="Kelurahan"
                            options={this.state.kelurahanOptions}
                            value={this.state.filter?.kelurahan}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_zip_code"
                            box="search"
                            name="kodePos"
                            label="Kode Pos"
                            options={this.state.kodePosOptions}
                            value={this.state.filter?.kodePos}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleInput
                            name="memberId"
                            label="Member ID"
                            value={this.state.filter?.memberId}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_member_level"
                            box="search"
                            name="memberLevel"
                            label="Member Level"
                            options={this.state.levelOptions}
                            value={this.state.filter?.memberLevel}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_loyalty_level"
                            box="search"
                            name="loyaltyLevel"
                            label="Loyalty Level"
                            options={this.state.loyaltyOptions}
                            value={this.state.filter?.loyaltyLevel}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_facebook"
                            box="search"
                            name="facebook"
                            label="Facebook"
                            options={this.state.socMedOptions}
                            value={this.state.filter?.facebook}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_instagram"
                            box="search"
                            name="instagram"
                            label="Instagram"
                            options={this.state.socMedOptions}
                            value={this.state.filter?.instagram}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_linkedin"
                            box="search"
                            name="linkedin"
                            label="LinkedIn"
                            options={this.state.socMedOptions}
                            value={this.state.filter?.linkedin}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_twitter"
                            box="search"
                            name="x"
                            label="X (Twitter)"
                            options={this.state.socMedOptions}
                            value={this.state.filter?.x}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_tiktok"
                            box="search"
                            name="tiktok"
                            label="TikTok"
                            options={this.state.socMedOptions}
                            value={this.state.filter?.tiktok}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_hobby"
                            box="multiselect"
                            name="hobby"
                            label="Hobby"
                            options={this.state.hobbyOptions}
                            value={this.state.filter?.hobby}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_interest"
                            box="multiselect"
                            name="interest"
                            label="Interest"
                            options={this.state.interestOptions}
                            value={this.state.filter?.interest}
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                        <FlexView style={{justifyContent: "center", marginTop: "20px", gap: "20px"}}>
                            <SimpleButton
                                onClick={this.handleReset}
                            >Reset</SimpleButton>
                            <SimpleButton
                                onClick={this.handleSubmit}
                            >Terapkan</SimpleButton>
                        </FlexView>
                    </ModalContainer>
                }
            />
        )
    }
}

export default CRMAssignFilter;
